import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import invarinat from 'invariant';
import AuthContext from '../AuthProvider/AuthContext';
var propTypes = {
  /** ({ isAuthenticated: boolean }) => Node */
  children: PropTypes.func,

  /** ({ isAuthenticated: boolean }) => Node */
  render: PropTypes.func
};
var defaultProps = {
  children: undefined,
  render: undefined
};
/**
 * Do render prop, nebo children func doplni propertu `isAuthenticated`, ktara obsahuje
 * `true` pokud je uzivatel prihlasen, jinak `false`.
 */

export default function IsAuthenticated(_ref) {
  var children = _ref.children,
      render = _ref.render,
      rest = _objectWithoutProperties(_ref, ["children", "render"]);

  invarinat(children || render, 'WithAuth at least one prop children or render have to be defined.');
  var renderer = children || render;
  return /*#__PURE__*/React.createElement(AuthContext.Consumer, null, function (_ref2) {
    var isAuthenticated = _ref2.isAuthenticated;
    return renderer(_extends({}, rest, {
      isAuthenticated: isAuthenticated
    }));
  });
}
IsAuthenticated.propTypes = propTypes;
IsAuthenticated.defaultProps = defaultProps;